import React from 'react';

import styles from './style.scss';


const BookPageHeaderEmpty = ({ hideControls }) => (
  <div className={styles.bookDetail}>
    <div>
      <div className={styles.title}>
        <div className={styles.header} />
      </div>
      <div className={styles.bookInfo}>
        <div className={styles.book}>
          <div className={styles.bookCover} />
        </div>
        <div>
          <div className={styles.rating} />
          <div className={styles.readCount} />
          <div className={styles.usersVoted} />
          <div className={styles.subscriptionType} />
        </div>
        {!hideControls && (
          <div className={styles.buttons}>
            <div className={styles.readBtn} />
            <div className={styles.appLink} />
            <div className={styles.ratingBtn} />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default BookPageHeaderEmpty;
